/*
  quantity-select.js
  ──────────────────
  PDP quantity dropdown: 1-9 as picked values, "+10" switches the control to
  the plain number input so the customer types the amount. The number input
  stays the only form-bound field (name="quantity" + form attr), so cart
  logic is untouched — the select just drives its value.
*/
(function () {
  if (window.__ggmQtySelect) return;
  window.__ggmQtySelect = true;

  document.addEventListener('change', function (e) {
    var select = e.target;
    if (!select.classList || !select.classList.contains('pm__quantity-select')) return;

    var wrapper = select.closest('quantity-input');
    if (!wrapper) return;
    var input = wrapper.querySelector('.pm__quantity-input');
    if (!input) return;

    if (select.value === 'more') {
      wrapper.classList.add('pm__quantity--manual');
      input.value = 10;
      input.focus();
      input.select();
    } else {
      input.value = select.value;
    }

    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
